import { CollateralComponent } from "projects/reg-hub-client/src/app/orders/collateral/collateral.component";
import { DebtorsComponent } from "projects/reg-hub-client/src/app/orders/debtors/debtors.component";
import { QCLienDetailsComponent } from "projects/reg-hub-client/src/app/orders/lien-details/qc-lien-details/qc-lien-details.component";
import { OrderChangesComponent } from "projects/reg-hub-client/src/app/orders/order-changes/order-changes.component";
import { ReviewComponent } from "projects/reg-hub-client/src/app/orders/review/review.component";
import { SecuredPartiesComponent } from "projects/reg-hub-client/src/app/orders/secured-parties/secured-parties.component";
import { Step, StepValidationState } from "projects/reg-hub-client/src/interfaces/step";
import { Stepper } from "projects/reg-hub-client/src/interfaces/stepper";

export class QCRDdAmendmentStepper implements Stepper {

    steps: Step[];

    constructor() {
        this.steps = [
            { title: "Details", content: QCLienDetailsComponent, validationState: StepValidationState.DefaultState },
            { title: "Debtors", content: DebtorsComponent, validationState: StepValidationState.DefaultState },
            { title: "Sec. Parties", content: SecuredPartiesComponent, validationState: StepValidationState.DefaultState },
            { title: "Collateral", content: CollateralComponent, validationState: StepValidationState.DefaultState },
            { title: "Changes", content: OrderChangesComponent, validationState: StepValidationState.DefaultState },
            { title: "Review", content: ReviewComponent, validationState: StepValidationState.DefaultState }
        ]
    }
}